import * as React from 'react';
import { RouteProps, Route, IndexRoute } from 'react-router';

export interface IExtendedRouteProps extends RouteProps {
	breadcrumbName?: string;
	breadcrumbLink?: string;
	breadcrumbIgnore?: boolean;
	to?: string;
	mode?: 'add' | 'edit';
	selectedTab?: string;
	darkHeader?: boolean;
	darkFooter?: boolean;
	landingPageHeader?: boolean;
	restrictedMode?: boolean;
	noHeader?: boolean;
	noFooter?: boolean;
}

const ExtendedRoute: React.ComponentClass<IExtendedRouteProps> = Route;
export const ExtendedIndexRoute: React.ComponentClass<IExtendedRouteProps> = IndexRoute;

export default ExtendedRoute;
